import { Measurement } from '../lib/constants';
import Logger from '../lib/logger';
import { addInsert$, modal$ } from "../lib/state";
import { InsertConfigData } from "../lib/types";
import { generateInsertId } from "../lib/util.functions";

class RingCushionInsertModal extends HTMLElement {
  #NAME = 'RingCustomInsertModal'
  #abortController: AbortController | null = null
  #form: HTMLFormElement
  #selectedDims = ['0','0'];

  constructor() {
    super();
    Logger.info(`${this.#NAME} > constructor`);
    this.#form = this.querySelector('form') as HTMLFormElement;
  }

  connectedCallback(): void {
    Logger.info(`${this.#NAME} > connectedCallback`);
    this.#abortController = new AbortController();
    const { signal } = this.#abortController;
    this.#form.addEventListener('submit', (e) => this.#onSubmit(e), { signal });
    this.#form.addEventListener('change', (e) => this.#onChange(e), { signal });
    this.#form.querySelector('input')?.dispatchEvent(new Event('change', { bubbles: true }));
  }

  disconnectedCallback(): void {
    Logger.info(`${this.#NAME} > disconnectedCallback`);
    this.#abortController?.abort();
    this.#abortController = null;
  }

  #onChange(e: Event): void {
    Logger.info(`${this.#NAME} > #onChange`);
    this.#selectedDims = (e.target as HTMLInputElement).id.split('x');
  }

  #onSubmit(e: SubmitEvent) {
    e.preventDefault();
    const configData: InsertConfigData = {
      type: 'cushion',
      id: generateInsertId(),
      unitWidth: parseFloat(this.#selectedDims[0]) + Measurement.SEP_WIDTH,
      unitHeight: parseFloat(this.#selectedDims[1]) + Measurement.SEP_WIDTH,
      x: 0,
      y: 0,
      title: undefined
    };
    Logger.info(`${this.#NAME} > #onSubmit >`, configData);
    addInsert$.next(configData);
    modal$.next({ show: false });
    setTimeout(() => {
      this.#form.reset();
    }, 500);
  }
}

customElements.define('cushion-insert-modal', RingCushionInsertModal);